import React, { useMemo } from 'react';
import { AppRow } from '../../layout/appRow';
import { format } from 'date-fns';
import { ColorPalette } from '../../styles/constants';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectProfile } from '../../store/profileSlice';
import { ReportFilters, ViewMode } from '../../models/reports';
import { useUserRoles } from '../../hooks/useUserRoles';
import { RolesNames } from '../../models/employee';
import { generateProjectLabel } from '../../services/projectService';
import {
   formatDateOnly,
} from '../../services/dateService';

interface ReportsInputsDataProps {
  filters: ReportFilters;
  viewMode: ViewMode;
}

const styles = {
  inputValue: {
    color: ColorPalette.RAISIN_BLACK,
  },
  inputDataRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    mb: 2,
  },
};

export function ReportsInputsData({
  filters,
  viewMode,
}: ReportsInputsDataProps): JSX.Element {
  const profile = useSelector(selectProfile);

  const { isAdmin } = useUserRoles();

  const {
    employeeName,
    managerName,
    projectName,
    projectCode,
    endDate,
    startDate,
    towerName,
  } = filters;

  const managerLabel = useMemo(() => {
    switch (viewMode) {
      case ViewMode.PEOPLE:
        return RolesNames.TEAM_LEAD;

      case ViewMode.PROJECT:
        return RolesNames.PROJECT_MANAGER;

      default:
        return 'Manager';
    }
  }, [viewMode]);

  const projectLabel = useMemo(
    () => generateProjectLabel(projectName || 'ALL', projectCode || ''),
    [projectName, projectCode]
  );

  return (
    <AppRow sx={styles.inputDataRow}>
      <Typography>
        {`${managerLabel}: `}
        <span style={styles.inputValue}>{`${
          managerName === null && isAdmin ? 'ALL' : managerName || profile?.name
        }`}</span>
      </Typography>
      <Typography>
        {`Engineer: `}
        <span style={styles.inputValue}>{`${employeeName || 'ALL'}`}</span>
      </Typography>
      <Typography>
        {`Project: `}
        <span style={styles.inputValue}>{projectLabel}</span>
      </Typography>
      <Typography>
        {`Tower: `}
        <span style={styles.inputValue}>{`${towerName || 'ALL'}`}</span>
      </Typography>
      <Typography>
        {`Begin date: `}
        <span style={styles.inputValue}>{`${format(
          new Date(formatDateOnly(startDate)),
          'dd/MM/yyy'
        )}`}</span>
      </Typography>
      <Typography>
        {`End date: `}
        <span style={styles.inputValue}>{`${format(
          new Date(formatDateOnly(endDate)),
          'dd/MM/yyy'
        )}`}</span>
      </Typography>
    </AppRow>
  );
}
